import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store/store';

const getState = (state: RootState) => state.zoho;

export const isLoadingZohoSelector = createSelector(getState, (state) => state.isLoadingZoho);
export const getKPIListSelector = createSelector(getState, (state) => state.list);
